module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as1406-60ce4969830da706e0157f2e88c73439.jpg";